import styled, { css, DefaultTheme } from 'styled-components';

import Heading from '../../components/Heading/Heading.styled';

type QuestionListPropsT = {
  isMuralToTheme: boolean;
};

const applyMuralToStyles = (theme: DefaultTheme) => css`
  li + li {
    padding-top: 30px;
    border-top: 1px solid ${theme.borderColour};
  }
`;

export const FaqWrapperStyled = styled.div`
  ${({ theme }) => `

    ${Heading} {
      color: ${theme.primaryColour};
    }
  `}
`;

export const MainTitleStyled = styled(Heading)`
  margin: 30px 0 50px;

  ${({ theme }) => `
    color: ${theme.primaryColour};
  `}
`;

export const QuestionListStyled = styled.ul<QuestionListPropsT>(
  ({ theme, isMuralToTheme }) => css`
    counter-reset: question;

    li + li {
      margin-top: 30px;
    }

    ${Heading} {
      margin-bottom: 10px;

      &::before {
        counter-increment: question;
        content: counter(question) '. ';
      }
    }

    ${isMuralToTheme ? applyMuralToStyles(theme) : ''};
  `
);
